// Store do Painel de News (comunicados/novidades criados no ADM)
import { apiGet, apiPost } from '@/api/conserv';

// News vigentes para o usuário logado (exclui arquivadas; traz flag lido)
export async function listaNews() {
    return apiGet('api/News/Listar');
}

// Marca uma news como lida (continua no painel, sai do badge)
export async function marcarNewsLida(id) {
    return apiPost(`api/News/MarcarLida?id=${encodeURIComponent(id)}`, '');
}

// Arquiva uma news (some do painel do usuário)
export async function arquivarNews(id) {
    return apiPost(`api/News/Arquivar?id=${encodeURIComponent(id)}`, '');
}
